module.exports = __webpack_public_path__ + "static/media/choix-upload-cg.0fc75143.svg";